export const getErrorLocation = (date, text, text2 = '') =>
  [text, text2].includes(date.error) ? 'tooltip' : 'placeholder';
